var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiarySidebaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.085,
    height: 36,
    viewBox: "0 0 34.085 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79266a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36667",
    "data-name": "Group 36667",
    transform: "translate(10541.62 -14871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "my_diary",
    "data-name": "my diary",
    transform: "translate(-10541.62 14871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57583",
    "data-name": "Path 57583",
    d: "M2.009,0h25.6a1.2,1.2,0,0,1,1.2,1.2V12h-6a6,6,0,1,0,0,12h6V34.8a1.2,1.2,0,0,1-1.2,1.2H2.009A2.836,2.836,0,0,1,.59,35.647,1.044,1.044,0,0,1,0,34.8V1.2A1.044,1.044,0,0,1,.59.352,2.836,2.836,0,0,1,2.009,0Z",
    fill: "#869b34",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57584",
    "data-name": "Path 57584",
    d: "M21.647,23.89A91.269,91.269,0,0,1,13.98,36H2.009A2.836,2.836,0,0,1,.59,35.651,1.044,1.044,0,0,1,0,34.8V24.974C8.69,18.039,13.112,8.1,15.036,0H27.608a1.2,1.2,0,0,1,1.178.975A40.981,40.981,0,0,1,26.731,12H22.809A6,6,0,0,0,21.647,23.89Z",
    transform: "translate(0 -0.004)",
    fill: "#abc73e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57585",
    "data-name": "Path 57585",
    d: "M81.773,40.225h22.351a1.2,1.2,0,0,0,1.2-1.2v-10.8h-6a6,6,0,0,1-2.817-.7A37.837,37.837,0,0,1,81.773,40.225Zm20.47-24h3.082V5.426a1.2,1.2,0,0,0-.353-.847q-.033-.033-.067-.063A50.39,50.39,0,0,1,102.243,16.226Z",
    transform: "translate(-76.517 -4.225)",
    fill: "#c7e64b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57586",
    "data-name": "Path 57586",
    d: "M299,227.6a3.611,3.611,0,0,0,3.6,3.6h6V224h-6a3.611,3.611,0,0,0-3.6,3.6Zm4.8,0a1.2,1.2,0,1,1-.352-.848A1.2,1.2,0,0,1,303.8,227.6Z",
    transform: "translate(-279.779 -209.6)",
    fill: "#9b3288"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7336",
    "data-name": "Ellipse 7336",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(21.139 16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36666",
    "data-name": "Group 36666",
    transform: "translate(-10510.648 14871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57595",
    "data-name": "Path 57595",
    d: "M260.113,99.445V69.557a1.557,1.557,0,0,0-3.113,0V99.445a1.557,1.557,0,0,0,3.113,0Z",
    transform: "translate(-257 -68)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_67",
    "data-name": "Polygon 67",
    d: "M1.413,0,2.826,3.768H0Z",
    transform: "translate(2.969 36) rotate(180)",
    fill: "#869b34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiarySidebaricon);
export default __webpack_public_path__ + "static/media/DiarySidebaricon.95945b6b0aa84be2e52afe9c1498d864.svg";
export { ForwardRef as ReactComponent };